/*
DEFINE CLIENT APP ROUTS 
*/
import React from "react";
import { Route, Switch } from "react-router-dom";

// pages
import Home from "../Pages/Home/Home";
import SpacielDeals from "../Pages/SpacielDeals/SpacielDeals";
import ExporeTelAvivAndJerusalem from "../Pages/ExporeTelAvivAndJerusalem/ExporeTelAvivAndJerusalem";
import TermsOfUse from "../Pages/TermsOfUse/TermsOfUse";
import ThingsToDo from "../Pages/ThingsToDo/ThingsToDo";
import WhereToGo from "../Pages/WhereToGo/WhereToGo";
import FAQ from "../Pages/FAQ/FAQ";
import GeneralPage from "../Pages/GeneralPage/GeneralPage";
import JewishPage from "../Pages/JewishPage/JewishPage";
import CulinaryPage from "../Pages/CulinaryPage/CulinaryPage";
import LgbtqPage from "../Pages/LgbtqPage/LgbtqPage";
import TouristInfoPage from "../Pages/TouristInfo/TouristInfoPage";
import ChristianPage from "../Pages/ChristianPage/ChristianPage";
import ActivePage from "../Pages/ActivePage/ActivePage";
import CoronaVirusPage from "../Pages/CoronaVirusPage/CoronaVirus";
import CoronaVirusPageCZ from "../Pages/CoronaVirusPage/CoronaVirusCZ";
import CoronaVirusPageDK from "../Pages/CoronaVirusPage/CoronaVirusDK";
import CoronaVirusPageHU from "../Pages/CoronaVirusPage/CoronaVirusHU";
import CoronaVirusPageNL from "../Pages/CoronaVirusPage/CoronaVirusNL";
import CoronaVirusPageRO from "../Pages/CoronaVirusPage/CoronaVirusRO";
import CoronaVirusPageSE from "../Pages/CoronaVirusPage/CoronaVirusSE";
import InterestsChristian from "../Pages/InterestsChristian/InterestsChristian";
import InterestsMice from "../Pages/InterestsMice/InterestsMice";
import InterestsJewish from "../Pages/InterestsJewish/InterestsJewish";
import InterestsGeneral from "../Pages/InterestsGeneral/InterestsGeneral";

import SearchPage from "../Pages/SearchPage/SearchPage";
// Posts
import VideosPosts from "../Posts/Videos/Videos";
import ConcertsPosts from "../Posts/Concerts/Concerts";
import Posts from "../Posts/Posts/Posts";

// Gallery
import GalleryTA from "../Pages/Gallery/TA/GalleryTA";
import GalleryJA from "../Pages/Gallery/JA/GalleryJA";
import LiveLandingBoard from "../Pages/LiveLandingBoard/LiveLandingBoard";
import PrivacyPolicy from "../Pages/PrivacyPolicy/PrivacyPolicy";
import ContactUs from "../Pages/ContactUs/ContactUs";
export const Routes = () => (
  <Switch>
    {/* <Route  path="/Pages/Interests" component={Interests} /> */}
    <Route path="/Pages/InterestsGeneral" component={InterestsGeneral} />
    <Route path="/Pages/InterestsJewish" component={InterestsJewish} />
    <Route path="/Pages/InterestsMice" component={InterestsMice} />
    <Route path="/Pages/InterestsChristian" component={InterestsChristian} />
    <Route path="/Pages/GeneralPage" component={GeneralPage} />
    <Route path="/Pages/ChristianPage" component={ChristianPage} />

    <Route path="/Pages/JewishPage" component={JewishPage} />
    <Route path="/Pages/CulinaryPage" component={CulinaryPage} />
    <Route path="/Pages/TouristInfoPage" component={TouristInfoPage} />
    <Route path="/Pages/CoronaVirusPage" component={CoronaVirusPage} />
    <Route path="/Pages/SearchPage" component={SearchPage} />
    <Route path="/Pages/FAQ" component={FAQ} />
    <Route path="/Pages/thingsToDo" component={ThingsToDo} />

    <Route path="/Pages/Gallery/" component={GalleryTA} />
    <Route path="/Pages/TermsOfUse" component={TermsOfUse} />
    <Route path="/Pages/PrivacyPolicy" component={PrivacyPolicy} />
    <Route path="/Pages/ContactUs" component={ContactUs} />
    <Route path="/Posts/:ctgId/:id" component={Posts} />

    {/* <Route  path="/Pages/Videos" component={ExporeTelAvivAndJerusalem} />
		  <Route  path="/Pages/ActivePage" component={ActivePage} />
		<Route  path="/Posts/Videos/:ctgId/:vidId" component={VideosPosts} /> 
		<Route  path="/Pages/LiveLandingBoard" component={LiveLandingBoard} />
		<Route  path="/Pages/whereToGo" component={WhereToGo} />
		<Route  path="/Pages/bestDeals" component={SpacielDeals} />
		<Route  path="/Pages/Gallery/:galleryId" component={GalleryTA} />
		 <Route  path="/Pages/CoronaVirusPageCZ" component={CoronaVirusPageCZ} />
		 
	    <Route  path="/Pages/LgbtqPage" component={LgbtqPage} />
		<Route  path="/Pages/CoronaVirusPageDK" component={CoronaVirusPageDK} />
		<Route  path="/Pages/CoronaVirusPageHU" component={CoronaVirusPageHU} />
		<Route  path="/Pages/CoronaVirusPageNL" component={CoronaVirusPageNL} />
		<Route  path="/Pages/CoronaVirusPageRO" component={CoronaVirusPageRO} />
		<Route  path="/Pages/CoronaVirusPageSE" component={CoronaVirusPageSE} /> */}

    <Route path="/" component={Home} />
  </Switch>
);



// WEBPACK FOOTER //
// ./src/Routes/Routes.js